import { useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import { BreadcrumbItem } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { callApiWithAuthorization } from '../../API/CallApi';
import NavigationComponent from '../../Components/Navigation/Navigation';
import PricingForm from '../../Components/Pricing/PricingForm';
import Loader from '../../Components/Shared/Loader/loader';
import PricingContextProvider from '../../Context/Pricing/PricingContext';
import { NoAccessPage } from '../404/NoAccess';

export function PricingPage(props) {

    const { accounts } = useMsal();
    const params = useParams();

    const [state, setState] = useState({
        loading: true,
        userHasAccess: false,
        currentOrganization: {},
        userRole: ""
    })

    async function validateAccess() {
        const { organisationId } = params;
        const getUserOrganisationsRequest = await callApiWithAuthorization("/api/v0/getOrganizationUserRole/" + accounts[0].username)
        const userOrganisations = await getUserOrganisationsRequest.json();
        const currentOrganization = userOrganisations.find(organisation => (
            organisation.id === organisationId
        ));
        if (currentOrganization) {
            setState({
                loading: false,
                userHasAccess: true,
                currentOrganization,
                userRole: currentOrganization.roleType
            })
        } else {
            setState({
                loading: false,
                userHasAccess: false
            })
        }
    }

    useEffect(() => {
        validateAccess();
    }, [])

    if (state.loading) {
        return <Loader />
    }

    if (state.userHasAccess === false) {
        return (
            <NoAccessPage
                userRole={state.userRole}
                user={state.user}
                isOwner={state.userRole === "Owner"}
                newUser={accounts[0].idTokenClaims.newUser}
                orgName={params.organisationName}
                organizations={[]}
                organizationId={""}
                email={accounts[0].username} />
        )
    }
    
    return (
        <>
            <NavigationComponent
                user={props.user}
                advancedMode={props.advancedMode}
                userRole={props.userRole}
                projectId={props.projectId}
                OrgName={""}
                organizations={[]}
                projectUrl={props.projectUrl}
                hideInviteButton={true}
            >
                <BreadcrumbItem>
                    { state.currentOrganization && state.currentOrganization.number }
                </BreadcrumbItem>
            </NavigationComponent>
            <div className='h-100'>
                <PricingContextProvider>
                    <PricingForm
                        userRole={state.userRole}
                        organization={state.currentOrganization} />
                </PricingContextProvider>
            </div>
        </>
    )
}